// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__SEO2H","title":"profile_title__ucHjW","list":"profile_list__eLAfo","item":"profile_item__XCQ-I","leave":"profile_leave__z-S12"};